import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=37c59e2f&scoped=true"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=37c59e2f&lang=scss"
import style1 from "./dashboard.vue?vue&type=style&index=1&id=37c59e2f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c59e2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37c59e2f')) {
      api.createRecord('37c59e2f', component.options)
    } else {
      api.reload('37c59e2f', component.options)
    }
    module.hot.accept("./dashboard.vue?vue&type=template&id=37c59e2f&scoped=true", function () {
      api.rerender('37c59e2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/dashboard.vue"
export default component.exports